import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import Layout from "@/components/Layout";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Home, ArrowLeft, AlertTriangle } from "lucide-react";
import { Link } from "react-router-dom";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
    // cleaned: removed debug console logs
  }, [location.pathname]);

  return (
    <Layout>
      <section className="py-20 px-4 min-h-[60vh] flex items-center justify-center">
        <div className="container mx-auto max-w-2xl text-center">
          <Card className="p-8 bg-card/50 border-primary/20">
            <CardHeader>
              <div className="w-20 h-20 mx-auto bg-destructive/10 rounded-full flex items-center justify-center mb-6">
                <AlertTriangle className="w-10 h-10 text-destructive" />
              </div>
              <CardTitle className="text-4xl lg:text-5xl font-bold mb-4">404</CardTitle>
              <p className="text-xl text-muted-foreground mb-8">
                Seite nicht gefunden
              </p>
            </CardHeader>
            <CardContent>
              <p className="text-muted-foreground mb-8">
                Die angeforderte Seite konnte nicht gefunden werden. 
                Möglicherweise wurde sie verschoben oder gelöscht.
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Button variant="primary" asChild className="px-6 py-3">
                  <Link to="/">
                    <Home className="w-4 h-4 mr-2" />
                    Zur Startseite
                  </Link>
                </Button>
                
                <Button variant="outline" onClick={() => window.history.back()} className="px-6 py-3">
                  <ArrowLeft className="w-4 h-4 mr-2" />
                  Zurück
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      </section>
    </Layout>
  );
};

export default NotFound;
